// extracted by mini-css-extract-plugin
export default {"slideContainer":"cH57e","slide":"JrFmn"};